export interface LoaderContext {
  source: string,
  showLoader: boolean
}

export const loaderDefaultSource = 'global';
